import { DOCUMENT, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { environment } from '../../environments/environment';

/** Old POS admin paths that were renamed in kottra-admin. */
const RENAMED_PATHS: Record<string, string> = {
   customers: 'stores',
};

/**
 * The super-admin area moved to the kottra-admin app. Any `/admin/...` URL
 * is sent to the same page there (kottra-admin falls back to its dashboard
 * for paths it doesn't know).
 */
export const adminRedirectGuard: CanActivateFn = (_route, state) => {
   const document = inject(DOCUMENT);
   const [path, query = ''] = state.url.replace(/^\/admin\/?/, '').split('?');
   const [first, ...rest] = path.split('/');
   const target = [RENAMED_PATHS[first] ?? first, ...rest].join('/');
   document.location.assign(
      `${environment.adminAppUrl}/${target}${query ? `?${query}` : ''}`,
   );
   return false;
};
